import { CpaStatus } from '../data-layer/cpa/types';
import { useCurrentUser } from '../routing/users/useCurrentUser';
import { isBlogger, isSuperAdmin } from './accessService';

export const useIsAdvertisingCatalogEnabled = () => {
    const currentUser = useCurrentUser();
    const role = currentUser?.role;
    const cpaStatus = currentUser?.cpaStatus;

    return (
        (isBlogger(role) || isSuperAdmin(role)) &&
        cpaStatus &&
        [CpaStatus.TRIAL, CpaStatus.ACCEPTED, CpaStatus.MODERATION].includes(cpaStatus)
    );
};
